/* Target Archery – product page: gallery, totals, local nav / sticky add-to-bag, "Pairs well with" */
(() => {
  const section = document.querySelector('[data-ta-main-product]');
  if (!section) return;

  const TA = window.TA || {};
  const strings = window.taStrings || {};
  const sectionId = section.dataset.section;
  const buybox = section.querySelector('[data-ta-buybox]');
  const form = document.getElementById(`product-form-${sectionId}`);
  const qtyInput = section.querySelector('[data-ta-qty]');
  const stickybar = section.querySelector('[data-ta-stickybar]');
  const variantData = (() => {
    const el = section.querySelector('variant-selects script[type="application/json"]');
    try {
      return el ? JSON.parse(el.textContent) : null;
    } catch (e) {
      return null;
    }
  })();

  let variant = variantData
    ? variantData.find((v) => form && String(v.id) === form.querySelector('[name="id"]').value) || variantData[0]
    : null;

  const money = (cents) => (TA.formatMoney ? TA.formatMoney(cents) : (cents / 100).toFixed(2));
  const qty = () => Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);
  const price = () => (variant ? variant.price : parseInt(buybox && buybox.dataset.price, 10) || 0);
  const available = () => (variant ? variant.available : !!(form && !form.querySelector('[name="add"]').disabled));

  /* ---------- Gallery ---------- */

  const gallery = section.querySelector('[data-ta-gallery]');
  const showMedia = (id) => {
    if (!gallery || !id) return;
    const item = gallery.querySelector(`.ta-gallery__item[data-media-id="${id}"]`);
    if (!item) return;
    gallery.querySelectorAll('.ta-gallery__item').forEach((el) => el.classList.toggle('is-active', el === item));
    gallery.querySelectorAll('[data-ta-thumb]').forEach((el) => el.classList.toggle('is-active', el.dataset.taThumb === String(id)));
  };
  const stepMedia = (dir) => {
    const items = [...gallery.querySelectorAll('.ta-gallery__item')];
    if (items.length < 2) return;
    const i = items.findIndex((el) => el.classList.contains('is-active'));
    const next = items[(i + dir + items.length) % items.length];
    showMedia(next.dataset.mediaId);
  };
  if (gallery) {
    gallery.addEventListener('click', (e) => {
      const thumb = e.target.closest('[data-ta-thumb]');
      if (thumb) showMedia(thumb.dataset.taThumb);
      const step = e.target.closest('[data-ta-gallery-step]');
      if (step) stepMedia(parseInt(step.dataset.taGalleryStep, 10));
    });
    // Swipe on touch devices
    const stage = gallery.querySelector('.ta-gallery__stage');
    let startX = null;
    stage.addEventListener('touchstart', (e) => (startX = e.touches[0].clientX), { passive: true });
    stage.addEventListener('touchend', (e) => {
      if (startX === null) return;
      const dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 40) stepMedia(dx < 0 ? 1 : -1);
      startX = null;
    });
  }

  /* ---------- Totals & labels ---------- */

  // Special-order template (no buy box): nothing to buy from the local nav either
  if (!form) {
    document.querySelectorAll('.ta-localnav__buy').forEach((el) => (el.hidden = true));
  }

  const refresh = () => {
    if (!form) return;
    const total = money(price() * qty());
    document.querySelectorAll('[data-ta-total]').forEach((el) => (el.textContent = total));
    if (variant) {
      const label = variant.options.join(' · ');
      if (variant.title !== 'Default Title') {
        document.querySelectorAll('[data-ta-variant-label]').forEach((el) => (el.textContent = label));
      }
    }
    const local = document.querySelector('[data-ta-local-price]');
    if (local) local.textContent = money(price());
    const cta = available() ? strings.addToBag : strings.soldOut;
    document.querySelectorAll('[data-ta-buy-trigger]').forEach((el) => (el.textContent = cta));
    if (buybox) buybox.dataset.price = price();
    document.dispatchEvent(new CustomEvent('ta:variant', { detail: { variant, price: price(), available: available() } }));
  };

  qtyInput && qtyInput.addEventListener('change', refresh);

  // Image of the chosen variant in the "Your new …" summary
  const summaryImg = section.querySelector('[data-ta-summary-img]');
  const showVariantImage = (v) => {
    if (!v) return;
    if (v.featured_media) showMedia(v.featured_media.id);
    const src = v.featured_image && v.featured_image.src;
    if (summaryImg && src) {
      summaryImg.src = `${src}${src.includes('?') ? '&' : '?'}width=320`;
    }
  };

  // Switch the image straight away when an option changes (before Dawn's section refresh).
  // Each option is either a <select> (dropdown) or a fieldset of radios (tiles / swatches).
  const picker = section.querySelector('variant-selects');
  if (picker && variantData) {
    picker.addEventListener('change', () => {
      const chosen = [...picker.querySelectorAll('.product-form__input')].map((wrap) => {
        const select = wrap.querySelector('select');
        if (select) return select.value;
        const checked = wrap.querySelector('input[type="radio"]:checked');
        return checked ? checked.value : null;
      });
      const match = variantData.find((v) => v.options.every((o, i) => o === chosen[i]));
      showVariantImage(match);
    });
  }

  // Dawn's variant change event (price, stock, button are refreshed by global.js).
  // PUB_SUB_EVENTS is a top-level const in constants.js – not a window property.
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
      if (data.sectionId !== sectionId) return;
      variant = data.variant;
      showVariantImage(variant);
      refresh();
    });
  }

  /* ---------- Local nav + sticky bar buttons ---------- */

  document.addEventListener('click', (e) => {
    if (!e.target.closest('[data-ta-buy-trigger]')) return;
    if (available() && form) {
      form.requestSubmit ? form.requestSubmit() : form.querySelector('[name="add"]').click();
    } else if (buybox) {
      buybox.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  });

  if (stickybar && buybox && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver(
      ([entry]) => {
        const passed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        stickybar.classList.toggle('is-visible', passed);
        stickybar.setAttribute('aria-hidden', String(!passed));
        stickybar.querySelectorAll('button').forEach((b) => (b.tabIndex = passed ? 0 : -1));
      },
      { rootMargin: '-100px 0px 0px 0px' }
    );
    io.observe(buybox);
  }

  refresh();
})();

/* "Pairs well with" set */
(() => {
  const TA = window.TA || {};
  const strings = window.taStrings || {};
  document.querySelectorAll('[data-ta-pairs]').forEach((box) => {
    const totalEl = box.querySelector('[data-ta-set-total]');
    const countEl = box.querySelector('[data-ta-set-count]');
    const addBtn = box.querySelector('[data-ta-set-add]');
    const main = box.querySelector('[data-ta-pair-main]');
    let mainPrice = parseInt(main && main.dataset.price, 10) || 0;
    let mainAvailable = main ? main.dataset.available === 'true' : false;

    const update = () => {
      let total = mainAvailable ? mainPrice : 0;
      let count = mainAvailable ? 1 : 0;
      box.querySelectorAll('[data-ta-pair]').forEach((item) => {
        const cb = item.querySelector('input[type="checkbox"]');
        const on = cb && cb.checked;
        item.classList.toggle('is-off', !on);
        if (on) {
          total += parseInt(item.dataset.price, 10) || 0;
          count += 1;
        }
      });
      if (totalEl) totalEl.textContent = TA.formatMoney ? TA.formatMoney(total) : total;
      if (countEl) countEl.textContent = (strings.items || '[count] items').replace('[count]', count);
      if (addBtn) addBtn.disabled = count === 0;
    };

    box.addEventListener('change', update);

    document.addEventListener('ta:variant', (e) => {
      mainPrice = e.detail.price;
      mainAvailable = e.detail.available;
      if (main) {
        const label = main.querySelector('[data-ta-pair-price]');
        if (label && TA.formatMoney) label.textContent = TA.formatMoney(mainPrice);
      }
      update();
    });

    addBtn &&
      addBtn.addEventListener('click', () => {
        const items = [];
        if (mainAvailable) {
          const form = document.querySelector('[data-ta-main-product] form[data-type="add-to-cart-form"]');
          const id = form && form.querySelector('[name="id"]').value;
          if (id) items.push({ id: parseInt(id, 10), quantity: 1 });
        }
        box.querySelectorAll('[data-ta-pair]').forEach((item) => {
          const cb = item.querySelector('input[type="checkbox"]');
          if (cb && cb.checked) items.push({ id: parseInt(item.dataset.variantId, 10), quantity: 1 });
        });
        if (!items.length || !TA.addToCart) return;
        TA.addToCart(items, { button: addBtn }).catch((err) => {
          const box2 = box.querySelector('[data-ta-set-error]');
          if (box2) {
            box2.textContent = err.message || strings.cartError;
            box2.hidden = false;
          }
        });
      });

    update();
  });
})();
